import { ProjectRoleType } from '@platform/client/schemas';
// import { DoerIcon } from './images/DoerIcon';
import { CoachIcon } from './images/CoachIcon';
import { TrainerIcon } from './images/TrainerIcon';
import { MentorIcon } from './images/MentorIcon';
import { ConsultantIcon } from './images/ConsultantIcon';

export const formatLocation = (city: string, country: string) => {
  if (!city.length && !!country.length) {
    return country;
  } else if (!!city.length && !!country.length) {
    return `${city}, ${country}`;
  } else {
    return undefined;
  }
};

export type DisplayRoleTypeData = {
  icon: () => JSX.Element;
  label: string;
  description: string;
};

export const ConsultantDisplayData: DisplayRoleTypeData = {
  icon: ConsultantIcon,
  label: 'Consultant',
  description:
    'Typically part-time or full-time for 2 weeks to 6 months, providing expert insights, recommending strategies, and supporting the implementation of solutions.',
};

export const DisplayDataForRoleType: Record<ProjectRoleType, DisplayRoleTypeData> = {
  // Legacy value; currently shows same info as Consultant
  doer: ConsultantDisplayData,
  coach: {
    icon: CoachIcon,
    label: 'Coach',
    description:
      'Typically 1-2 hours a week for 2 to 4 months, guiding others to overcome challenges and discover their own solutions to grow their business, strengthen their team, or advance personally.',
  },
  trainer: {
    icon: TrainerIcon,
    label: 'Trainer',
    description:
      'Typically involves 2-8 hours of team training, where you create materials and facilitate sessions that help teams learn and grow.',
  },
  mentor: {
    icon: MentorIcon,
    label: 'Mentor',
    description:
      'Typically 1-2 meetings per month over 3 to 6 months. Share your expertise and practical know-how to help teams build skills, make better decisions, and gain fresh perspectives. ',
  },
  consultant: ConsultantDisplayData,
  // Legacy value; currently shows same info as Consultant
  connector: ConsultantDisplayData,
};
